import moment from 'moment';

export const formatDate = (value, formatting = 'YYYY-MM-DD') => {
    const result = moment(value).format(formatting);
    if (result && result !== 'Invalid date') {
        return result;
    }
    return value;
};
